import { ProductTypeCode } from '@shared/model/product';
import { UserRoles } from '@shared/model/user';

export const buyProductText = ({
    price,
    withoutPrice,
    hasManager,
    userRole,
    productType,
}: {
    price: number;
    hasManager: boolean;
    withoutPrice?: boolean;
    userRole?: UserRoles;
    productType?: ProductTypeCode;
}) => {
    const isUser = userRole === UserRoles.Employee;
    const isManager = userRole === UserRoles.Manager;

    if (withoutPrice) {
        return 'Запросить условия';
    }

    switch (productType) {
        case ProductTypeCode.Course:
        case ProductTypeCode.OfflineMeeting:
        case ProductTypeCode.OnlineMeeting: {
            if (price === 0) {
                return 'Принять участие';
            }
            if (price > 0) {
                if (isManager || (isUser && !hasManager)) {
                    return 'Приобрести';
                }
                if (isUser && hasManager) {
                    return 'Согласовать';
                }
            }
            break;
        }

        case ProductTypeCode.License:
        case ProductTypeCode.File:
        case ProductTypeCode.Demo: {
            if (price === 0) {
                return 'Получить';
            }
            if (price > 0) {
                if (isManager || (isUser && !hasManager)) {
                    return 'Приобрести';
                }
                if (isUser && hasManager) {
                    return 'Согласовать';
                }
            }
            break;
        }
    }

    return '';
};
